import { render, staticRenderFns } from "./ContactPersons.vue?vue&type=template&id=2d7fd053&"
import script from "./ContactPersons.vue?vue&type=script&lang=js&"
export * from "./ContactPersons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/juodeliai/miskovezis-core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7fd053')) {
      api.createRecord('2d7fd053', component.options)
    } else {
      api.reload('2d7fd053', component.options)
    }
    module.hot.accept("./ContactPersons.vue?vue&type=template&id=2d7fd053&", function () {
      api.rerender('2d7fd053', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/resources/static/js/app/components/common/ContactPersons.vue"
export default component.exports